import "./instrument";
import { createRoot } from "react-dom/client";
import "./main.css";
import { Auth0Provider } from "@auth0/auth0-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import "./i18n";
import * as Sentry from "@sentry/react";
import jssVariables from "./jss_setup";
import { queryClient } from "./queryClient";

const withAuth = import.meta.env.VITE_APP_PRIVATE_WEBSITE === "true";
const brand = import.meta.env.VITE_APP_BRANDNAME || "";

// Conditionally load Google Analytics only for travily brand
if (brand === "travily") {
  // Initialize dataLayer
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  gtag("js", new Date());
  gtag("config", "G-NL3JB7CNYV");

  // Load the gtag.js script
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-NL3JB7CNYV";
  document.head.appendChild(script);
}

const auth0ProviderProps = {};

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      {withAuth ? (
        <Sentry.ErrorBoundary fallback={<div>Error</div>}>
          <Auth0Provider
            domain={import.meta.env.VITE_APP_AUTH0_DOMAIN}
            clientId={import.meta.env.VITE_APP_AUTH0_CLIENTID}
            useRefreshTokens={true}
            authorizationParams={{
              redirect_uri: `${window.location.origin}/authnavigator`,
              /* redirect_uri: window.location.origin, */
              logo: import.meta.env.VITE_APP_LOGO || "",
              background_img: import.meta.env.VITE_APP_AUTH0_BACKGROUND || "",
              base_color: jssVariables.colors.base_color,
              title: import.meta.env.VITE_APP_AUTH0_TITLE || "",
            }}
            {...auth0ProviderProps}
          >
            <App />
          </Auth0Provider>
        </Sentry.ErrorBoundary>
      ) : (
        <Sentry.ErrorBoundary fallback={<div>Error</div>}>
          <App />
        </Sentry.ErrorBoundary>
      )}
    </Provider>
  </QueryClientProvider>,
);
